import type { AssessmentCheckboxChoice, AssessmentRateValue } from "@/core/types";

import type { QuestionOption } from "../types";

export const adaptCheckboxOptions = (choices: AssessmentCheckboxChoice[]): QuestionOption[] => {
  return choices.map((choice, index) => {
    if (typeof choice === "string") {
      return {
        index: String(index + 1),
        label: choice,
        value: choice,
      };
    }

    return {
      index: String(index + 1),
      isExclusive: choice.isExclusive,
      label: choice.text,
      value: choice.value,
    };
  });
};

export const adaptRadiogroupOptions = (choices: string[]): QuestionOption[] => {
  return choices.map((choice, idx) => ({
    index: String(idx + 1),
    label: choice,
    value: choice,
  }));
};

export const adaptRatingOptions = (rateValues: AssessmentRateValue[]): QuestionOption[] => {
  return rateValues.map((rate) => ({
    label: rate.text,
    value: String(rate.value),
  }));
};
